/* eslint-disable no-var */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable arrow-body-style */
// import React from 'react'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import AddIcon from '@mui/icons-material/Add';
import { Delete } from '@mui/icons-material';
import Skeleton from '@mui/material/Skeleton';
import RefreshIcon from '@mui/icons-material/Refresh';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link, useNavigate } from 'react-router-dom';
import swal from 'sweetalert2';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useBillingStore } from '../../store/billingStore';
import { clearAllStores } from '../../store/resetStores';
import { billingService } from '../../services/billingService';
import MySwiper from '../MySwiper/MySwiper';
import './Billing.css';
import Histroy from './Histroy';
import { getApiErrorMessage, uniqueErrorMessages } from '../../utils/getApiErrorMessage';
// import CreditCardForm from './CreditForm';

const RECHARGE_SELECT_AMOUNTS = ['10', '25', '50', '100'];
const THRESHOLD_SELECT_AMOUNTS = ['5', '10', '25', '50', '100'];

/** DB 0 means auto-recharge off; must not bind select to "0" (browser shows first option). */
function profileRechargeSelectValue(raw) {
  if (raw === undefined || raw === null || raw === '') return '';
  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) return '';
  const s = String(n);
  return RECHARGE_SELECT_AMOUNTS.includes(s) ? s : '';
}

function profileThresholdSelectValue(raw) {
  if (raw === undefined || raw === null || raw === '') return '';
  const s = String(raw);
  return THRESHOLD_SELECT_AMOUNTS.includes(s) ? s : '';
}

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&::before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&::after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));

const Billing = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [amount, setAmount] = useState('');
  const [cardholderName, setCardholderName] = useState('');
  const [isPrimary, setIsPrimary] = useState(true);
  // Empty = not configured in Firestore. Never hardcode 25/10 as fake "saved" values.
  const [autoRechargeWith, setAutoRechargeWith] = useState('');
  const [balanceLowerThan, setBalanceLowerThan] = useState('');
  const [tgAutoRechargeWith, setTgAutoRechargeWith] = useState('');
  const [tgBalanceLowerThan, setTgBalanceLowerThan] = useState('');
  const [addcardloader, setAddCardloader] = useState(false);
  const [cardActionLoader, setCardActionLoader] = useState(false);
  const [creditActionLoader, setCreditActionLoader] = useState(false);
  const [index, setIndex] = useState(1);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => {
    if (creditActionLoader) return;
    setShow1(false);
    setAmount('');
  };
  const handleShow1 = () => {
    setAmount('');
    setShow1(true);
  };

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    if (creditActionLoader) return;
    setShow2(false);
    setAmount('');
  };
  const handleShow2 = () => {
    setAmount('');
    setShow2(true);
  };

  const MIN_RECHARGE_USD = 0.5;
  const MAX_RECHARGE_USD = 10000;

  const validateRechargeAmount = (rawAmount) => {
    if (rawAmount === undefined || rawAmount === null || String(rawAmount).trim() === '') {
      return 'Amount is required.';
    }
    const value = Number(rawAmount);
    if (!Number.isFinite(value)) {
      return 'Amount must be a valid number.';
    }
    if (value <= 0) {
      return 'Amount must be greater than 0.';
    }
    if (value < MIN_RECHARGE_USD) {
      return 'Minimum recharge amount is $0.50.';
    }
    if (value > MAX_RECHARGE_USD) {
      return 'Maximum recharge amount is $10,000.';
    }
    return null;
  };

  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);
  const {
    cards,
    billingHistory,
    profile,
    loading,
    fetchErrors,
    fetchCards,
    fetchBillingHistory,
    fetchProfile,
    hydrateBillingData,
    clearBillingFetchErrors,
  } = useBillingStore();

  const aggregatedBillingErrors = uniqueErrorMessages([
    fetchErrors.cards,
    fetchErrors.history,
    fetchErrors.profile,
  ]);
  const balance = profile?.balance || 0;
  const tgBalance = profile?.tgBalance || 0;
  const tgCredits = profile?.tgCredits || 0;
  const credits = profile?.credits || 0;
  const loader = loading.cards || cardActionLoader;
  const billingloader = loading.history;
  const creditloader = loading.profile || creditActionLoader;

  const Navigate = useNavigate();
  const handleLogout = () => {
    clearAllStores();
    localStorage.clear();
    Navigate('/login');
  };

  const handleSubmit = async () => {
    const { error: submitError } = await elements.submit();

    if (submitError) {
      setErrorMessage(submitError.message);
    } else if (!cardholderName) {
      swal.fire({
        title: 'Card name required.',
        icon: 'error',
      });
    } else {
      setAddCardloader(true);

      const card = elements.getElement(CardElement);
      await stripe
        .createPaymentMethod({
          type: 'card',
          card,
          billing_details: {
            name: cardholderName,
          },
        })
        .then((res) => {
          const { error } = res;

          if (error) {
            setAddCardloader(false);
            swal.fire({
              title: "Card couldn't be added",
              text: error.message,
              icon: 'error',
            });
          } else {
            // Phase 6: Billing calls now go through billingService.
            billingService
              .addCard({ paymentMethodId: res.paymentMethod.id, isPrimary })
              .then(() => {
                setAddCardloader(false);
                getCards();
                setCardholderName('');
                handleClose();
              })
              .catch((error2) => {
                setAddCardloader(false);
                swal.fire({
                  title: "Card couldn't be added",
                  text: getApiErrorMessage(error2, "Card couldn't be added. Please try again."),
                  icon: 'error',
                });
              });
          }
        })
        .catch((err) => {
          setAddCardloader(false);
          swal.fire({
            title: "Card couldn't be added",
            text: err.description,
            icon: 'error',
          });
        });
    }
  };

  useEffect(() => {
    // Phase 6: Hydrate cached billing state and refresh in background if stale.
    hydrateBillingData();
  }, [hydrateBillingData]);

  useEffect(() => {
    if (!profile) return;
    setAutoRechargeWith(profileRechargeSelectValue(profile.autoRechargeWith));
    setBalanceLowerThan(profileThresholdSelectValue(profile.balanceLowerThan));
    setTgAutoRechargeWith(profileRechargeSelectValue(profile.tgAutoRechargeWith));
    setTgBalanceLowerThan(profileThresholdSelectValue(profile.tgBalanceLowerThan));
  }, [profile]);

  const getBillingHistory = () => {
    fetchBillingHistory({ force: true, background: false }).catch((err) => {
      swal.fire({
        title: 'Billing history',
        icon: 'error',
        text: getApiErrorMessage(err, 'Could not refresh billing history.'),
      });
    });
  };

  const getCards = () => {
    fetchCards({ force: true, background: false }).catch((err) => {
      swal.fire({
        title: 'Payment methods',
        icon: 'error',
        text: getApiErrorMessage(err, 'Could not refresh payment methods.'),
      });
    });
  };

  const getBalance = () => {
    fetchProfile({ force: true, background: false }).catch((err) => {
      swal.fire({
        title: 'Wallet balance',
        icon: 'error',
        text: getApiErrorMessage(err, 'Could not refresh wallet balance.'),
      });
    });
  };

  const handleAddBalance = () => {
    if (creditActionLoader) return;

    const amountError = validateRechargeAmount(amount);
    if (amountError) {
      swal.fire({ title: amountError, icon: 'error' });
      return;
    }
    if (cards.length === 0) {
      swal.fire({
        title: 'You have to add card before adding a balance',
        icon: 'error',
      });
      return;
    }
    if (!cards?.[0]?.isPrimary) {
      swal.fire({
        title: 'Please make a card primary before adding balance.',
        icon: 'error',
      });
      return;
    }

    const rechargeAmount = Number(Number(amount).toFixed(2));
    setCreditActionLoader(true);
    billingService
      .addFunds({ amount: rechargeAmount })
      .then((res) => {
        if (res?.status >= 200 && res?.status < 300) {
          getBalance();
          setShow1(false);
          setAmount('');
          swal.fire({
            title: 'Balance added successfully',
            icon: 'success',
            timer: 1800,
            showConfirmButton: false,
          });
        }
      })
      .catch((error) => {
        console.error('[billing.addFunds]', error?.response?.data || error);
        swal.fire({
          title: 'Amount could not be added',
          icon: 'error',
          text: getApiErrorMessage(error, 'Amount could not be added. Please try again.'),
        });
      })
      .finally(() => {
        setCreditActionLoader(false);
      });
  };

  const handleAddTgBalance = () => {
    if (creditActionLoader) return;

    const amountError = validateRechargeAmount(amount);
    if (amountError) {
      swal.fire({ title: amountError, icon: 'error' });
      return;
    }
    if (cards.length === 0) {
      swal.fire({
        title: 'You have to add card before adding a balance',
        icon: 'error',
      });
      return;
    }
    if (!cards?.[0]?.isPrimary) {
      swal.fire({
        title: 'Please make a card primary before adding balance.',
        icon: 'error',
      });
      return;
    }

    const rechargeAmount = Number(Number(amount).toFixed(2));
    setCreditActionLoader(true);
    billingService
      .addTgFunds({ amount: rechargeAmount })
      .then((res) => {
        if (res?.status >= 200 && res?.status < 300) {
          getBalance();
          setShow2(false);
          setAmount('');
          swal.fire({
            title: 'Balance added successfully',
            icon: 'success',
            timer: 1800,
            showConfirmButton: false,
          });
        }
      })
      .catch((error) => {
        console.error('[billing.addTgFunds]', error?.response?.data || error);
        swal.fire({
          title: 'Amount could not be added',
          icon: 'error',
          text: getApiErrorMessage(error, 'Amount could not be added. Please try again.'),
        });
      })
      .finally(() => {
        setCreditActionLoader(false);
      });
  };

  const handleAutoRechargeChange = (e) => {
    setCreditActionLoader(true);

    billingService
      .updateAutoRecharge({ amount: e.target.value })
      .then(async (res) => {
        if (res.data) {
          setCreditActionLoader(false);

          // await stripe.confirmCardPayment(res.data.secret);
          getBalance();
          handleClose1();
          getBillingHistory();
        }
      })
      .catch((err) => {
        setCreditActionLoader(false);
        swal.fire({
          title: 'Auto-recharge',
          icon: 'error',
          text: getApiErrorMessage(err, 'Could not update auto-recharge.'),
        });
      });
  };

  const handleTgAutoRechargeChange = (e) => {
    setCreditActionLoader(true);

    billingService
      .updateTgAutoRecharge({ amount: e.target.value })
      .then(async (res) => {
        if (res.data) {
          setCreditActionLoader(false);

          // await stripe.confirmCardPayment(res.data.secret);
          getBalance();
          handleClose2();
          getBillingHistory();
        }
      })
      .catch((err) => {
        setCreditActionLoader(false);
        swal.fire({
          title: 'Auto-recharge',
          icon: 'error',
          text: getApiErrorMessage(err, 'Could not update auto-recharge.'),
        });
      });
  };

  const handleBalancelowerthenChange = (e) => {
    setCreditActionLoader(true);

    billingService
      .updateBalanceLowerThan({ amount: e.target.value })
      .then(async (res) => {
        if (res.data) {
          setCreditActionLoader(false);

          // await stripe.confirmCardPayment(res.data.secret);
          getBalance();
          handleClose1();
        }
      })
      .catch((err) => {
        setCreditActionLoader(false);
        swal.fire({
          title: 'Balance threshold',
          icon: 'error',
          text: getApiErrorMessage(err, 'Could not update threshold.'),
        });
      });
  };

  const handleTgBalancelowerthenChange = (e) => {
    setCreditActionLoader(true);

    billingService
      .updateTgBalanceLowerThan({ amount: e.target.value })
      .then(async (res) => {
        if (res.data) {
          setCreditActionLoader(false);

          // await stripe.confirmCardPayment(res.data.secret);
          getBalance();
          handleClose2();
        }
      })
      .catch((err) => {
        setCreditActionLoader(false);
        swal.fire({
          title: 'Balance threshold',
          icon: 'error',
          text: getApiErrorMessage(err, 'Could not update threshold.'),
        });
      });
  };

  const handleMakeCardPrimary = (id) => {
    // setloader(true);
    billingService
      .makeCardPrimary({ paymentMethodId: id })
      .then(async (res) => {
        if (res.data) {
          getCards();
        }
      })
      .catch((err) => {
        swal.fire({
          title: 'Primary card',
          icon: 'error',
          text: getApiErrorMessage(err, 'Could not update primary card.'),
        });
      });
  };

  const handleRemoveCard = () => {
    swal
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085D6',
        cancelButtonColor: '#D33',
        confirmButtonText: 'Yes, delete it!',
      })
      .then((result) => {
        if (result.isConfirmed) {
          setCardActionLoader(true);
          billingService
            .removeCard({ paymentMethodId: cards?.[index - 1]?.id })
            .then(async (res) => {
              if (res.data) {
                setCardActionLoader(false);
                swal.fire({
                  title: 'Deleted!',
                  text: 'Your file has been deleted.',
                  icon: 'success',
                });
                getCards();
              }
            })
            .catch((err) => {
              setCardActionLoader(false);
              swal.fire({
                title: 'Could not remove card',
                icon: 'error',
                text: getApiErrorMessage(err, 'Could not remove card. Please try again.'),
              });
            });
        }
      });
  };

  return (
    <>
      <section className="px-0">
        <div className="">
          <div className="d-flex justify-content-between py-4">
            <div className="">
              <h5 className="">Voice AI Usage</h5>
            </div>
            <div className="">
              <Button
                variant="filled"
                className="px-4 rounded"
                fullWidth
                color="primary"
                sx={{
                  backgroundColor: '#63B3ED',
                  color: 'white',
                  borderRadius: 0,
                  ':hover': { backgroundColor: 'black' },
                }}
                startIcon={<PowerSettingsNewIcon />}
                onClick={() => handleLogout()}
              >
                Logout
              </Button>
            </div>
          </div>
          <div className="row">
            {aggregatedBillingErrors.length > 0 && (
              <div className="col-12">
                <Alert
                  severity="error"
                  onClose={() => clearBillingFetchErrors()}
                  sx={{ mb: 3 }}
                >
                  <AlertTitle>Billing could not be loaded</AlertTitle>
                  {aggregatedBillingErrors.map((line, idx) => (
                    <Typography
                      key={`${idx}-${line.slice(0, 40)}`}
                      component="div"
                      variant="body2"
                      sx={{ mt: idx > 0 ? 1 : 0 }}
                    >
                      {line}
                    </Typography>
                  ))}
                </Alert>
              </div>
            )}
            <div className="col-md-6">
              <div className="card rounded p-4">
                <h6 className="card-title">Payment methods</h6>

                {loader ? (
                  <div className="mt-4">
                    <Skeleton variant="rounded" height={210} sx={{ mb: 2 }} />
                    <div className="d-flex gap-2">
                      <Skeleton variant="rounded" width={120} height={40} />
                      <Skeleton variant="rounded" width={140} height={40} />
                    </div>
                  </div>
                ) : (
                  <div className="card-body p-0 py-4">
                    <div className="row">
                      <div className="col-md-9">
                        {cards.length > 0 ? (
                          <div className="swiper-container">
                            <MySwiper
                              index={index}
                              setIndex={setIndex}
                              cards={cards}
                              handleMakeCardPrimary={handleMakeCardPrimary}
                            />
                          </div>
                        ) : fetchErrors.cards ? (
                          <Typography variant="body2" color="error">
                            {fetchErrors.cards}
                          </Typography>
                        ) : (
                          <div>
                            No cards available in your account. Please add a new card to add balance to your Voice AI
                            wallet.
                          </div>
                        )}
                      </div>
                      <div className="col-md-3 px-1">
                        <div className="button-export mx-1">
                          <Button
                            variant="filled"
                            className="px-1 rounded"
                            fullWidth
                            color="primary"
                            sx={{ backgroundColor: '#63B3ED', color: 'white', ':hover': { background: 'black' } }}
                            startIcon={<AddIcon />}
                            onClick={handleShow}
                          >
                            Add Card
                          </Button>
                        </div>
                        {cards.length > 0 && (
                          <div className="button-export mt-2">
                            <div className="button-export mx-1">
                              <Button
                                variant="outline"
                                className="px-1 rounded"
                                fullWidth
                                color="inherit"
                                startIcon={<Delete />}
                                sx={{
                                  border: '1px solid red',
                                  color: 'red',
                                }}
                                onClick={handleRemoveCard}
                              >
                                Remove Card
                              </Button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="card my-3 rounded">
                <div className="d-flex justify-content-between p-4 pb-0">
                  <h6 className="card-title center-block">Voice AI Wallet Balance</h6>
                  {cards.length > 0 && (
                    <Button
                      variant="filled"
                      className="px-4 rounded"
                      color="primary"
                      sx={{ backgroundColor: '#63B3ED', color: 'white', ':hover': { background: 'black' } }}
                      startIcon={<AddIcon />}
                      onClick={handleShow1}
                    >
                      Add Balance
                    </Button>
                  )}
                </div>

                <div className="card-body p-4">
                  <div style={{ background: '#C6F6D5', borderRadius: '6px' }} className="px-4 py-3">
                    {creditloader ? (
                      <div>
                        <Skeleton variant="text" width={180} height={30} />
                        <Skeleton variant="text" width={'100%'} height={28} />
                        <Skeleton variant="text" width={'100%'} height={28} />
                      </div>
                    ) : fetchErrors.profile ? (
                      <Typography variant="body2" color="error">
                        {fetchErrors.profile}
                      </Typography>
                    ) : (
                      <>
                        <div className="d-flex justify-content-between">
                          <h6>Total Balance</h6>
                          <h6 className="fw-bolder">${Number(balance + credits).toFixed(2)}</h6>
                        </div>
                        <div className="d-flex justify-content-between mt-3">
                          <p>Balance:</p>
                          <p className="fw-bolder"> ${Number(balance).toFixed(2)}</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <p>Complimentary Credits:</p>
                          <p className="fw-bolder">${Number(credits).toFixed(2)}</p>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="card-header mt-2 px-0">
                    <button
                      type="button"
                      className="fw-light text-dark fst-italic border-0 bg-white"
                      onClick={getBalance}
                    >
                      <i>
                        <RefreshIcon fontSize="small" sx={{ color: 'gray' }} />
                      </i>
                      Refresh
                    </button>
                    <div className="">
                      <Link to={'/dashboard/voice-ai-daily-stats'} style={{ cursor: 'pointer' }}>
                        <p className="fw-light text-primary">See Daily Stats</p>
                      </Link>
                      <Link to={'/dashboard/transaction'} style={{ cursor: 'pointer' }}>
                        <p className="fw-light text-primary">See Transactions</p>
                      </Link>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mt-4">
                    <div className="fs-6 d-flex justify-content-center align-items-center">Auto recharge with</div>
                    <div className="d-flex align-items-center">
                      $
                      <select
                        value={autoRechargeWith}
                        onChange={(e) => {
                          setAutoRechargeWith(e.target.value);
                          handleAutoRechargeChange(e);
                        }}
                        className="form-select ms-2"
                        aria-label="Select recharge amount"
                      >
                        <option value="">
                          {autoRechargeWith ? 'Select recharge amount' : 'Off — select to enable'}
                        </option>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mt-2">
                    <div className="fs-6 d-flex justify-content-center align-items-center">When balance lower than</div>
                    <div className="d-flex align-items-center">
                      $
                      <select
                        value={balanceLowerThan}
                        onChange={(e) => {
                          setBalanceLowerThan(e.target.value);
                          handleBalancelowerthenChange(e);
                        }}
                        className="form-select ms-2"
                        aria-label="Select minimum balance"
                      >
                        <option value="" disabled>
                          Select minimum balance
                        </option>
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card my-3 rounded">
                <div className="d-flex justify-content-between p-4 pb-0">
                  <h6 className="card-title center-block">Hybrid Wallet Balance</h6>
                  {cards.length > 0 && (
                    <Button
                      variant="filled"
                      className="px-4 rounded"
                      color="primary"
                      sx={{ backgroundColor: '#63B3ED', color: 'white', ':hover': { background: 'black' } }}
                      startIcon={<AddIcon />}
                      onClick={handleShow2}
                    >
                      Add Balance
                    </Button>
                  )}
                </div>

                <div className="card-body p-4">
                  <div style={{ background: '#C6F6D5', borderRadius: '6px' }} className="px-4 py-3">
                    {creditloader ? (
                      <div>
                        <Skeleton variant="text" width={180} height={30} />
                        <Skeleton variant="text" width={'100%'} height={28} />
                        <Skeleton variant="text" width={'100%'} height={28} />
                        <Skeleton variant="text" width={'100%'} height={28} />
                      </div>
                    ) : fetchErrors.profile ? (
                      <Typography variant="body2" color="error">
                        {fetchErrors.profile}
                      </Typography>
                    ) : (
                      <>
                        <div className="d-flex justify-content-between mt-3">
                          <p>Balance:</p>
                          <p className="fw-bolder"> ${Number(tgBalance).toFixed(2)}</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <p>Complimentary Credits:</p>
                          <p className="fw-bolder">${Number(tgCredits).toFixed(2)}</p>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="card-header mt-2 px-0">
                    <button
                      type="button"
                      className="fw-light text-dark fst-italic border-0 bg-white"
                      onClick={getBalance}
                    >
                      <i>
                        <RefreshIcon fontSize="small" sx={{ color: 'gray' }} />
                      </i>
                      Refresh
                    </button>
                    <Link to={'/dashboard/tg-transaction'} style={{ cursor: 'pointer' }}>
                      <p className="fw-light text-primary">See Transactions</p>
                    </Link>
                  </div>

                  <div className="d-flex justify-content-between mt-4">
                    <div className="fs-6 d-flex justify-content-center align-items-center">Auto recharge with</div>
                    <div className="d-flex align-items-center">
                      $
                      <select
                        value={tgAutoRechargeWith}
                        onChange={(e) => {
                          setTgAutoRechargeWith(e.target.value);
                          handleTgAutoRechargeChange(e);
                        }}
                        className="form-select ms-2"
                        aria-label="Select hybrid recharge amount"
                      >
                        <option value="">
                          {tgAutoRechargeWith ? 'Select recharge amount' : 'Off — select to enable'}
                        </option>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                  </div>
                  {!tgAutoRechargeWith && (
                    <p className="text-muted small mb-0 mt-1">
                      Hybrid auto-recharge is off until you choose an amount above.
                    </p>
                  )}

                  <div className="d-flex justify-content-between mt-2">
                    <div className="fs-6 d-flex justify-content-center align-items-center">When balance lower than</div>
                    <div className="d-flex align-items-center">
                      $
                      <select
                        value={tgBalanceLowerThan}
                        onChange={(e) => {
                          setTgBalanceLowerThan(e.target.value);
                          handleTgBalancelowerthenChange(e);
                        }}
                        className="form-select ms-2"
                        aria-label="Select hybrid minimum balance"
                      >
                        <option value="" disabled>
                          Select minimum balance
                        </option>
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card scroll py-2 rounded">
                <div className="card-header border-0">
                  <h6 className="card-title">Billing History</h6>
                  <button
                    type="button"
                    onClick={getBillingHistory}
                    className="fw-light text-dark fst-italic border-0 bg-white"
                  >
                    <i>
                      <RefreshIcon fontSize="small" sx={{ color: 'gray' }} />
                    </i>
                    Refresh
                  </button>
                </div>
                <div className="card-body p-0">
                  {billingloader ? (
                    <div className="p-4">
                      <Skeleton variant="rounded" height={70} sx={{ mb: 2 }} />
                      <Skeleton variant="rounded" height={70} sx={{ mb: 2 }} />
                      <Skeleton variant="rounded" height={70} />
                    </div>
                  ) : billingHistory.length ? (
                    billingHistory.map((val) => <Histroy key={val.id ?? `${val.created}-${val.amount}`} {...val} />)
                  ) : fetchErrors.history ? (
                    <div className="p-4 text-danger">{fetchErrors.history}</div>
                  ) : (
                    <div className="p-4">No transactions found</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal show={show} onHide={handleClose} centered keyboard={false}>
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold ">Add Card</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="">
              <TextField
                sx={{
                  '.MuiInput-input': {
                    color: '#000 !important',
                  },
                }}
                onChange={(e) => setCardholderName(e.target.value)}
                fullWidth
                id="outlined-basic"
                label="Enter name on card"
                variant="outlined"
                size="medium"
              />
              <div
                className="border rounded px-2 py-3 mt-3 justify-content-center align-items-center"
                style={{ height: '56px' }}
              >
                <CardElement
                  options={{
                    hidePostalCode: true,
                    disableLink: true,
                  }}
                />
                {errorMessage && <div>{errorMessage}</div>}
              </div>
              <div className="d-flex justify-content-start align-items-center mt-2">
                <FormControlLabel
                  className="px-2"
                  control={<Android12Switch defaultChecked />}
                  onChange={(e) => setIsPrimary(e.target.checked)}
                  checked={isPrimary}
                  label="Make this card primary"
                />
              </div>

              <h6 className="my-2 px-1" style={{ fontSize: '12px' }}>
                By providing your card information, you allow Agent Suite to charge your card for future payments in
                accordance with their terms.
              </h6>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleSubmit();
            }}
            className="text-white"
            color="success"
          >
            Add Card{' '}
            {addcardloader && (
              <Skeleton
                variant="circular"
                width={20}
                height={20}
                sx={{ marginLeft: '5px', bgcolor: 'rgba(255,255,255,0.5)' }}
              />
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={show1}
        onHide={handleClose1}
        centered
        keyboard={!creditActionLoader}
        backdrop={creditActionLoader ? 'static' : true}
      >
        <Modal.Header closeButton={!creditActionLoader} className="border-0">
          <Modal.Title className="fw-bold ">Add money to Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4">
            <FormControl fullWidth sx={{ m: 1 }} variant="standard">
              <InputLabel htmlFor="standard-adornment-amount-voice">Enter Amount</InputLabel>
              <Input
                id="standard-adornment-amount-voice"
                value={amount}
                disabled={creditActionLoader}
                type="number"
                inputProps={{ min: MIN_RECHARGE_USD, max: MAX_RECHARGE_USD, step: '0.01' }}
                sx={{
                  '.MuiInput-input': {
                    color: '#000 !important',
                  },
                }}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                onChange={(e) => setAmount(e.target.value)}
              />
            </FormControl>
            <h6 className="my-4" style={{ fontSize: '12px' }}>
              Current Balance: <strong>${(balance + credits).toFixed(2)}</strong>
            </h6>
            <h6 className="my-4" style={{ fontSize: '12px' }}>
              Min $0.50 · Max $10,000
            </h6>
            <h6 className="my-4" style={{ fontSize: '12px' }}>
              {cards?.[0]?.isPrimary ? (
                <span>
                  Your <strong>{cards?.[0]?.brand}</strong> card ending in <strong>{cards?.[0]?.last4}</strong> will be
                  charged.
                </span>
              ) : (
                'Add a new card or make your card primary'
              )}
            </h6>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose1} disabled={creditActionLoader}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddBalance}
            className="text-white"
            color="success"
            disabled={creditActionLoader || !cards?.[0]?.isPrimary}
          >
            {creditActionLoader ? 'Processing…' : 'Proceed'}
            {creditActionLoader && (
              <Skeleton
                variant="circular"
                width={20}
                height={20}
                sx={{ marginLeft: '5px', bgcolor: 'rgba(255,255,255,0.5)' }}
              />
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={show2}
        onHide={handleClose2}
        centered
        keyboard={!creditActionLoader}
        backdrop={creditActionLoader ? 'static' : true}
      >
        <Modal.Header closeButton={!creditActionLoader} className="border-0">
          <Modal.Title className="fw-bold ">Add money to Hybrid Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4">
            <FormControl fullWidth sx={{ m: 1 }} variant="standard">
              <InputLabel htmlFor="standard-adornment-amount-hybrid">Enter Amount</InputLabel>
              <Input
                id="standard-adornment-amount-hybrid"
                value={amount}
                disabled={creditActionLoader}
                type="number"
                inputProps={{ min: MIN_RECHARGE_USD, max: MAX_RECHARGE_USD, step: '0.01' }}
                sx={{
                  '.MuiInput-input': {
                    color: '#000 !important',
                  },
                }}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                onChange={(e) => setAmount(e.target.value)}
              />
            </FormControl>
            <h6 className="my-4" style={{ fontSize: '12px' }}>
              Current Balance: <strong>${(tgBalance + tgCredits).toFixed(2)}</strong>
            </h6>
            <h6 className="my-4" style={{ fontSize: '12px' }}>
              Min $0.50 · Max $10,000
            </h6>
            <h6 className="my-4" style={{ fontSize: '12px' }}>
              {cards?.[0]?.isPrimary ? (
                <span>
                  Your <strong>{cards?.[0]?.brand}</strong> card ending in <strong>{cards?.[0]?.last4}</strong> will be
                  charged.
                </span>
              ) : (
                'Add a new card or make your card primary'
              )}
            </h6>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose2} disabled={creditActionLoader}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddTgBalance}
            className="text-white"
            color="success"
            disabled={creditActionLoader || !cards?.[0]?.isPrimary}
          >
            {creditActionLoader ? 'Processing…' : 'Proceed'}
            {creditActionLoader && (
              <Skeleton
                variant="circular"
                width={20}
                height={20}
                sx={{ marginLeft: '5px', bgcolor: 'rgba(255,255,255,0.5)' }}
              />
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Billing;
